import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, Sun, Utensils } from 'lucide-react';
export function ThreeAnchors() {
  const anchors = [{
    icon: Moon,
    title: '1) Rutina de cierre',
    time: '5–15 min',
    desc: 'Para que tu cuerpo entienda que el día terminó.'
  }, {
    icon: Sun,
    title: '2) Mañana RRH',
    time: '10 min',
    desc: 'Luz + agua + movimiento mínimo para encender el sistema sin nervio.'
  }, {
    icon: Utensils,
    title: '3) Proteína ancla',
    time: 'En comidas',
    desc: 'Para evitar que tu energía se convierta en una montaña rusa.'
  }];
  return <section className="py-24 bg-[#faf8f5] text-[#1a1f3a]" data-id="element-202">
      <div className="container mx-auto px-6" data-id="element-203">
        <FadeIn data-id="element-204">
          <div className="text-center mb-16" data-id="element-205">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-206">
              Las 3 anclas{' '}
              <span className="text-[#8da399] font-sans font-normal text-2xl" data-id="element-207">
                (el corazón del método)
              </span>
            </h2>
            <p className="text-lg text-gray-600" data-id="element-208">
              Este protocolo se sostiene con 3 acciones pequeñas.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-209">
          {anchors.map((anchor, i) => <FadeIn key={i} delay={i * 200} data-id="element-210">
              <div className="bg-white p-8 rounded-2xl shadow-lg border-b-4 border-[#d4a574] h-full hover:-translate-y-1 transition-transform duration-300" data-id="element-211">
                <div className="w-14 h-14 bg-[#faf8f5] rounded-full flex items-center justify-center mb-6 text-[#1a1f3a]" data-id="element-212">
                  <anchor.icon className="w-7 h-7" data-id="element-213" />
                </div>
                <div className="flex justify-between items-start mb-4" data-id="element-214">
                  <h3 className="text-xl font-bold" data-id="element-215">{anchor.title}</h3>
                  <span className="text-xs font-bold bg-[#1a1f3a] text-white px-2 py-1 rounded-md" data-id="element-216">
                    {anchor.time}
                  </span>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-217">{anchor.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={600} data-id="element-218">
          <div className="text-center mt-16" data-id="element-219">
            <p className="text-2xl font-serif italic text-[#1a1f3a]" data-id="element-220">
              "No te pido perfección. Te doy estructura."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}